import styled from 'styled-components';
import themedColor, {
  ThemedColorReturn
} from '../../../styles/theme/themed-color';
import styleUtils from '../../../styles/style.utils';
import mediaBreakpoints from '../../../styles/media-breakpoints';
import themedFontSize from '../../../styles/theme/themed-font-size';

interface BackgroundContainerProps {
  fillBackground: boolean;
}
const BackgroundContainer = styled.div<BackgroundContainerProps>`
  background: ${({
    fillBackground
  }: BackgroundContainerProps): ThemedColorReturn =>
    fillBackground ? themedColor('FORM_BG') : themedColor('WHITE')};
  padding: ${({ fillBackground }: BackgroundContainerProps): string =>
    fillBackground ? `${styleUtils.px(48)} 0 0` : `0`};

  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div {
    padding: 0 16px;
  }
  ${mediaBreakpoints.greaterThan('L')`        
    max-width: ${styleUtils.size('MAX_CONTAINER_WIDTH')};
  `};
`;

const SubmitButton = styled.button`
  border: none;
  outline: 0;
  background: ${themedColor('BUTTON_DARK_BG')};
  color: ${themedColor('BUTTON_DARK_TEXT')};
  border: 1px solid ${themedColor('BUTTON_DARK_BORDER')};
  height: ${styleUtils.px(50)};
  min-width: ${styleUtils.px(240)};
  padding: 0 ${styleUtils.px(32)};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${styleUtils.px(25)};
  cursor: pointer;
  margin: ${styleUtils.px(18)} auto ${styleUtils.px(36)} auto;

  p {
    margin-bottom: 0;
    color: ${themedColor('BUTTON_DARK_TEXT')};
    font-size: ${themedFontSize('BODY')};
  }

  &:hover p {
    text-decoration: underline;
  }
`;

interface SpacingProps {
  addMargin?: boolean;
}

const Spacing = styled.div<SpacingProps>`
  width: 100%;
  margin-bottom: ${({ addMargin }: SpacingProps): string =>
    addMargin ? styleUtils.px(32) : '0'};
`;

const CaptchaContainer = styled.div`
  width: 100%;
`;
const ContactFieldsComponents = {
  Container,
  BackgroundContainer,
  SubmitButton,
  Spacing,
  CaptchaContainer
};

export default ContactFieldsComponents;
